module.exports = __webpack_public_path__ + "img/weiterbildung3.74a7ceb3.png";